export interface LogOpsRequest {
  message: string
  data?: any
}

export interface ErrorOpsRequest {
  message: string
}
